/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const NECESSARY_LEVEL_MESSAGE = (
    <FormattedMessage
        id='command_center_card.nessesary_level'
        defaultMessage='Требуемый суммарный уровень строений:'
    />
)

export const BUILDINGS_LEVEL_MESSAGE = (
    <FormattedMessage
        id='command_center_card.buildings_level_summ'
        defaultMessage='текущий:'
    />
)

export const BUILDINGS_LEVEL_LACKS_MESSAGE = (
    <FormattedMessage
        id='command_center_card.buildings_level_summ_lacks'
        defaultMessage='не хватает:'
    />
)


export const MAX_LEVEL_MESSAGE = (
    <FormattedMessage
        id='command_center_card.max_level_message'
        defaultMessage='Позволяет модернизировать все строения до Х уровня.'
    />
)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/CardImage/constants.jsx